import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { A_TOKENS, POOL_ADDRESSES } from '../constants';
export var Repay = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'repay',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaHandHoldingUsd }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    interestRateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }], isPreview: true }),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {
                amountRepaid: new FctValue({ innerIndex: 0 }),
            },
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount, onBehalfOf = _a.onBehalfOf;
        var value;
        if (typeof amount.value === 'string') {
            value = amount.value;
        }
        if (!value && typeof amount.estimatedValue === 'string') {
            value = amount.estimatedValue;
        }
        if (!value)
            return [];
        return [
            {
                to: asset.value,
                from: onBehalfOf.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, asset = _a.asset, onBehalfOf = _a.onBehalfOf, interestRateMode = _a.interestRateMode;
        if (!interestRateMode.value || !asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress)
            return [];
        if (typeof interestRateMode.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string')
            return [];
        var assetData = A_TOKENS[chainId].find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!assetData)
            return [];
        var debtToken = interestRateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
        return [
            {
                address: vaultAddress,
                toSpend: [
                    // NOTE: I am not sure if this is entirely correct.
                    // It might be that we need to do offchain calls.
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                    {
                        token: debtToken,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
            {
                address: to.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
